define("shared/utils/formatters/caption-from-regram", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  /**
   * Formats caption text from IG post to also include mediaSource and username
   *
   * @method formatRegramCaption
   * @param {Object} IG post attributes
   *
   * @returns {String} Returns a formatted caption
   */
  const formatRegramCaption = _ref => {
    let {
      caption = '',
      username,
      link,
      commentText,
      commentUsername = ''
    } = _ref;
    const mediaSource = "Media Source: ".concat(link);
    const postCredit = username ? "( #\uD83D\uDCF7 @".concat(username, " )") : '';
    const commentCredit = commentText ? "".concat(commentText, " (@").concat(commentUsername, ")") : commentUsername;
    return [mediaSource, "".concat(caption, " ").concat(postCredit).trim(), commentCredit].filter(i => i).join('\n\n');
  };

  var _default = formatRegramCaption;
  _exports.default = _default;
});